import { Component, Optional, Inject, Injector, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, UntypedFormControl } from '@angular/forms';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-color2',
    templateUrl: './input-color2.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputColor2Component),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => InputColor2Component),
            multi: true,
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputColor2Component extends InputBase<string>
{
    private static regexp = /^#{0,1}(?:(?:[a-fA-F0-9]{6})|(?:[a-fA-F0-9]{3}))$/;
    private static identifier = 0;

    constructor(
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        protected injector: Injector
    )
    {
        super(injector);
        this.fieldId = `input-color2-${InputColor2Component.identifier++}-id`;
    }

    validate ({ value }: UntypedFormControl)
    {
        if (!value)
        {
            return null;
        }

        return value.match(InputColor2Component.regexp) ? null : { colorPattern: true };
    }
}
